<section class="bread-block">
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['']">Головна</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/portfolio']">Портфоліо</a></li>
        <li class="breadcrumb-item">Бізнес Центр «Лекс»</li>
      </ol>
    </nav>
  </div>
</section>

<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">Бізнес Центр «Лекс»</div>
  </div>
</section>

<section class="slider">
  <div class="container">
    <div class="portfolio-owl owl-carousel owl-theme">
      <div class="slider-item">
        <img src="../../../../assets/images/lex/lex_1.jpg" alt="Бизнес Центр «Лекс»"
             class="img-fluid">
      </div>
      <div class="slider-item">
        <img src="../../../../assets/images/lex/lex_2.jpg" alt="Бизнес Центр «Лекс»"
             class="img-fluid">
      </div>
      <div class="slider-item">
        <img src="../../../../assets/images/lex/lex_1.jpg" alt="Бизнес Центр «Лекс»"
             class="img-fluid">
      </div>
    </div>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <p>Бізнес Центр «Лекс», м. Київ.</p>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">Проведені роботи</div>
    <ol>
      <li>Монтаж мультизональных систем MULTI V LG (Корея)</li>
      <li>Монтаж системи кондиціювання на 76 внутрішніх блоків холодопродуктивністю 185 кВт</li>
    </ol>
  </div>
</section>

<app-our-advantages></app-our-advantages>
<app-our-clients-small></app-our-clients-small>
<app-feedback></app-feedback>
<app-map></app-map>
